import { useConfirm } from './useConfirm'
import { useUpdateDemoSchoolGroup } from './mutations/useUpdateDemoSchoolGroup'
import { useDemoResources } from './useDemoResources'
import { useCurrentUser } from './useCurrentUser'

const useConfirmAddDemoSchoolGroup = () => {
  const { confirm } = useConfirm()
  const { currentUser } = useCurrentUser()
  const { demoSchoolGroups } = useDemoResources(currentUser ? { id: currentUser.id, connected: false } : null)
  const { post } = useUpdateDemoSchoolGroup()

  const confirmAddDemoSchoolGroup = async (onSuccess) => {
    const confirmed = await confirm({
      title: demoSchoolGroups[0].name,
      text: 'Är du säker på att du vill lägga till en ny demogrupp i ditt lärarrum?',
      confirmText: 'Ja, lägg till gruppen',
      cancelText: 'Avbryt',
    })

    if (!confirmed) return

    const res = await post({
      connected: true,
      id: demoSchoolGroups[0].id,
    }, 'Demogruppen har blivit tillagd i lärarrummet')

    if (res.success && typeof onSuccess == 'function') {
      onSuccess()
    }
  }

  return { confirmAddDemoSchoolGroup }
}

export { useConfirmAddDemoSchoolGroup }
